import { apiSlice } from "../../../app/api/apiSlice";
import { SearchResult } from "../../../types/types";

export const extendeHischoolApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    searchHigschoolwithagnacyName: builder.query<
    SearchResult[],
    { term: string, agancyName: string }
    >({
      query: ({ term, agancyName }) =>
        `/highschool/searchwithagancyname?term=${term}&agancyName=${agancyName}`,
      providesTags: ["HighSchool"]
    }),
  }),
});

export const {
  useSearchHigschoolwithagnacyNameQuery,
  useLazySearchHigschoolwithagnacyNameQuery
} = extendeHischoolApiSlice
